export const STORE_KEY = '$navbar'

export const GET_FILTERED_NAVBAR_PROGRAMS = 'GET_FILTERED_NAVBAR_PROGRAMS'
export const LOAD_PROGRAM = 'LOAD_PROGRAM'
export const LOAD_PROGRAMS_LIST = 'LOAD_PROGRAMS_LIST'
export const RESET_STORE = 'RESET_STORE'
export const SET_PROGRAMS_LIST = 'SET_PROGRAMS_LIST'
export const SET_PROGRAMS_LIST_QUERY = 'SET_PROGRAMS_LIST_QUERY'
export const SET_PROGRAM = 'SET_PROGRAM'
export const SET_LOADING = 'SET_LOADING'
